<!-- <app-tenant-as *ngIf="showTenantAs"></app-tenant-as> -->
@if (showLoginAs()) {
  <app-login-as></app-login-as>
}
<app-navbar [ngClass]="showHeader() ? '' : 'd-none'"></app-navbar>
<router-outlet></router-outlet>
@if (showFooter()) {
  <app-footer></app-footer>
}
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-spinner></app-spinner>